import { render, staticRenderFns } from "./ykgkCov.vue?vue&type=template&id=5909d47c&scoped=true"
import script from "./ykgkCov.vue?vue&type=script&lang=js"
export * from "./ykgkCov.vue?vue&type=script&lang=js"
import style0 from "./ykgkCov.vue?vue&type=style&index=0&id=5909d47c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909d47c",
  null
  
)

export default component.exports